import * as React from "react";

export interface DataTableColumnProps {
  className?: string;
  header: () => React.ReactNode;
  headerClassName?: string;
  fieldName: string;
  formatter: (row: any, index: number) => any;
  footer?: () => React.ReactNode;
  footerClassName?: string;
  tagName?: "td" | "th";
}

const DataTableColumn: React.FC<DataTableColumnProps> = () => null;
DataTableColumn.displayName = "DataTable.Column";
export default DataTableColumn;
